import { useWindowWidth } from '@react-hook/window-size';
import classNames from 'classnames';
import I18n from 'i18n-js';
import { bool, func, string } from 'prop-types';

import BottomPopupWithTransition from '~/components/BottomPopupWithTransition';
import Body from '~/components/SubscriptionOverview/NewView/PopupsSection/CancelSubscriptionPopup/Body';
import Footer from '~/components/SubscriptionOverview/NewView/PopupsSection/CancelSubscriptionPopup/Footer';

import useBooleanState from '~/hooks/useBooleanState';

import consts from '~/sass/consts.module.scss';

import styles from './CancelSubscriptionPopup.module.scss';

export default function CancelSubscriptionPopup({
  show,
  subscriptionValidUntil,
  toggleShow,
}) {
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < consts.mediumMobileView;

  const [animationStarted, toggleAnimationStarted] = useBooleanState(false);
  const [showCancelSubSummary, toggleShowCancelSubSummary] = useBooleanState();

  const closeSummaryPopup = () => {
    toggleShow();
    toggleAnimationStarted.setFalse();
    setTimeout(() => {
      toggleShowCancelSubSummary.setFalse();
    }, 50);
  };

  return (
    <>
      <BottomPopupWithTransition
        banner={I18n.t('season_ticket_welcome_headline_2')}
        bannerClassName={styles.banner}
        body={
          <Body
            summaryActive={isMobile || animationStarted}
            subscriptionValidUntil={subscriptionValidUntil}
          />
        }
        closeButtonEnabled
        closeButtonClassName={styles.closeButton}
        containerClassName={classNames(styles.popup)}
        footer={
          <Footer
            secondaryPopupActive={showCancelSubSummary}
            summaryActive={isMobile || animationStarted}
            toggleAnimationStarted={
              isMobile ? toggleShowCancelSubSummary : toggleAnimationStarted
            }
            toggleShow={toggleShow}
          />
        }
        onClose={closeSummaryPopup}
        show={show}
      />
      <BottomPopupWithTransition
        banner={I18n.t('season_ticket_welcome_headline_2')}
        bannerClassName={styles.banner}
        body={
          <Body
            secondaryPopup={isMobile}
            summaryActive
            subscriptionValidUntil={subscriptionValidUntil}
          />
        }
        closeButtonEnabled
        closeButtonClassName={styles.closeButton}
        containerClassName={classNames(styles.popup)}
        footer={
          <Footer
            secondaryPopup={isMobile}
            summaryActive
            toggleAnimationStarted={toggleAnimationStarted}
            toggleShow={closeSummaryPopup}
          />
        }
        onClose={closeSummaryPopup}
        show={showCancelSubSummary}
      />
    </>
  );
}

CancelSubscriptionPopup.propTypes = {
  show: bool,
  subscriptionValidUntil: string,
  toggleShow: func,
};
